export default __webpack_public_path__ + "static/media/paymentTutorial_pc_top_Hk.c5960269.webp";